define("settings/components/cluster/social-profile-item", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr class={{if this.showBasicDisplayDeprecation "tBD--tableRow"}} data-social-profile-id={{@socialProfile.id}}>
    <td>
  
      <Shared::ProfileAvatar @showPlatform={{true}} @socialProfile={{@socialProfile}}>
        <span class="o--user__title u--ellipsis {{this.socialProfileState.profile.class}}">
          {{#if @socialProfile.displayNickname}}
            {{@socialProfile.displayNickname}}
          {{else}}
            <span class="u--text--warning">
              <EmberTooltip @event="hover">
                {{t "account.social_accounts.tiktok.username_tooltip"}}
              </EmberTooltip>
              {{t "account.social_accounts.tiktok.username_not_available"}}
            </span>
          {{/if}}
        </span>
        <span class="o--user__desc {{this.socialProfileState.profile.class}}">
          {{@socialProfile.socialProfileState.profile.type}}
          {{#if this.showProfileInfo}}
            <span {{on "click" this.openProfileInfo}}>
              {{svg-jar "info" class="o--icon"}}
            </span>
          {{else if @socialProfile.isLinkedin}}
            |
            {{if @socialProfile.isLinkedinPersonalProfile (t "shared_words.profile") (t "linkedin.page")}}
            <span {{on "click" @openLinkedinProfileInfoModal}}>
              {{svg-jar "info" class="o--icon"}}
            </span>
          {{else if @socialProfile.isSnapchat}}
            <span class="u--text--uppercase">({{t "shared_words.beta"}})</span>
          {{/if}}
        </span>
      </Shared::ProfileAvatar>
      <span class="o--user u--text--sm" data-test-id="profile-item-business-setup">
        {{#if this.socialProfileState.profile.showInstagramLink}}
          <Shared::Ui::Button
            @onClick={{set this "showBasicDisplayDeprecationWizard" true}}
            @text={{t "account.social_accounts.instagram.business_setup"}}
            @variant="actionLink"
            class="u--text--underline u--text--light u--p__0"
            formtarget="_blank"
          />
        {{/if}}
      </span>
    </td>
    <td class={{this.socialProfileState.status.titleClass}}>
      <span>
        {{this.socialProfileState.status.title}}
      </span>
      {{#if this.socialProfileState.status.showInfo}}
        <span {{on "click" @openTiktokConnectionStatusModal}}>
          {{svg-jar "info" class="o--icon"}}
        </span>
      {{/if}}
      <br />
      <span class="u--text--sm {{this.socialProfileState.status.descriptionClass}}">
        {{this.socialProfileState.status.description}}
      </span>
    </td>
    <td>
      {{#if this.socialProfileState.action.text}}
        <span class="u--text--sm u--text--light">
          {{html-safe this.socialProfileState.action.text}}
        </span>
      {{else}}
        <Cluster::SocialProfileRefresh
          @openInstagramAuthStatus={{@openInstagramAuthStatus}}
          @socialProfile={{@socialProfile}}
          @socialProfileState={{this.socialProfileState}}
        />
      {{/if}}
    </td>
    <td>
      <Shared::Ui::Button
        @onClick={{@disconnect}}
        @text={{t "shared_words.remove"}}
        @variant="unstyled"
        class="o--btn o--btn--mute qa--socialProfile_remove_btn"
        data-test-id="profile-item-remove"
      />
    </td>
  </tr>
  
  {{#if @socialProfile.isTwitter}}
    <tr>
      <td class="tBD--tableDataAlert" colspan="4">
        <AlertBanner @type="warning" class="tBD--alert">
          {{#if this.rolloutTwitterSunset}}
            {{t "twitter-deprecation.alert_banner.message_rollout"}}
          {{else}}
            {{t "twitter-deprecation.alert_banner.message"}}
          {{/if}}
          <Shared::Ui::Button
            @onClick={{this.enableTwitterDeprecationModal}}
            @size="small"
            @text={{t "shared_words.learn_more"}}
            @variant="none"
            class="o--alert__btn o--alert--warning u--m__t__0"
          />
        </AlertBanner>
      </td>
    </tr>
  {{/if}}
  
  {{#if this.showBasicDisplayDeprecation}}
    <tr>
      <td class="tBD--tableDataAlert" colspan="4">
        <AlertBanner @type="warning" class="tBD--alert">
          {{t "basic-display-deprecation.settings.description"}}
          <Shared::Ui::Button
            @onClick={{set this "showBasicDisplayDeprecationWizard" true}}
            @size="small"
            @text={{t "basic-display-deprecation.settings.button"}}
            @variant="none"
            class="o--alert__btn o--alert--warning u--m__t__0"
          />
        </AlertBanner>
      </td>
    </tr>
  {{/if}}
  
  {{#if this.showBasicDisplayDeprecationWizard}}
    <Shared::Social::BasicDisplayDeprecation::Wizard
      @closeWizard={{set this "showBasicDisplayDeprecationWizard" false}}
      @returnToModal={{set this "showBasicDisplayDeprecationWizard" false}}
    />
  {{/if}}
  
  {{#if this.showTwitterDeprecationModal}}
    <Shared::Social::TwitterDeprecation::Modal @closeModal={{set this "showTwitterDeprecationModal" false}} />
  {{/if}}
  */
  {
    "id": "IIYuINvG",
    "block": "[[[10,\"tr\"],[15,0,[52,[30,0,[\"showBasicDisplayDeprecation\"]],\"tBD--tableRow\"]],[15,\"data-social-profile-id\",[30,1,[\"id\"]]],[12],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n\\n    \"],[8,[39,1],null,[[\"@showPlatform\",\"@socialProfile\"],[true,[30,1]]],[[\"default\"],[[[[1,\"\\n      \"],[10,1],[15,0,[29,[\"o--user__title u--ellipsis \",[30,0,[\"socialProfileState\",\"profile\",\"class\"]]]]],[12],[1,\"\\n\"],[41,[30,1,[\"displayNickname\"]],[[[1,\"          \"],[1,[30,1,[\"displayNickname\"]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,1],[14,0,\"u--text--warning\"],[12],[1,\"\\n            \"],[8,[39,2],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,3],[\"account.social_accounts.tiktok.username_tooltip\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n            \"],[1,[28,[35,3],[\"account.social_accounts.tiktok.username_not_available\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n      \"],[10,1],[15,0,[29,[\"o--user__desc \",[30,0,[\"socialProfileState\",\"profile\",\"class\"]]]]],[12],[1,\"\\n        \"],[1,[30,1,[\"socialProfileState\",\"profile\",\"type\"]]],[1,\"\\n\"],[41,[30,0,[\"showProfileInfo\"]],[[[1,\"          \"],[11,1],[4,[38,4],[\"click\",[30,0,[\"openProfileInfo\"]]],null],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"info\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isLinkedin\"]],[[[1,\"          |\\n          \"],[1,[52,[30,1,[\"isLinkedinPersonalProfile\"]],[28,[37,3],[\"shared_words.profile\"],null],[28,[37,3],[\"linkedin.page\"],null]]],[1,\"\\n          \"],[11,1],[4,[38,4],[\"click\",[30,2]],null],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"info\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isSnapchat\"]],[[[1,\"          \"],[10,1],[14,0,\"u--text--uppercase\"],[12],[1,\"(\"],[1,[28,[35,3],[\"shared_words.beta\"],null]],[1,\")\"],[13],[1,\"\\n        \"]],[]],null]],[]]]],[]]],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[10,1],[14,0,\"o--user u--text--sm\"],[14,\"data-test-id\",\"profile-item-business-setup\"],[12],[1,\"\\n\"],[41,[30,0,[\"socialProfileState\",\"profile\",\"showInstagramLink\"]],[[[1,\"        \"],[8,[39,6],[[24,0,\"u--text--underline u--text--light u--p__0\"],[24,\"formtarget\",\"_blank\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,7],[[30,0],\"showBasicDisplayDeprecationWizard\",true],null],[28,[37,3],[\"account.social_accounts.instagram.business_setup\"],null],\"actionLink\"]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[15,0,[30,0,[\"socialProfileState\",\"status\",\"titleClass\"]]],[12],[1,\"\\n    \"],[10,1],[12],[1,\"\\n      \"],[1,[30,0,[\"socialProfileState\",\"status\",\"title\"]]],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"socialProfileState\",\"status\",\"showInfo\"]],[[[1,\"      \"],[11,1],[4,[38,4],[\"click\",[30,3]],null],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"info\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,\"br\"],[12],[13],[1,\"\\n    \"],[10,1],[15,0,[29,[\"u--text--sm \",[30,0,[\"socialProfileState\",\"status\",\"descriptionClass\"]]]]],[12],[1,\"\\n      \"],[1,[30,0,[\"socialProfileState\",\"status\",\"description\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n\"],[41,[30,0,[\"socialProfileState\",\"action\",\"text\"]],[[[1,\"      \"],[10,1],[14,0,\"u--text--sm u--text--light\"],[12],[1,\"\\n        \"],[1,[28,[35,8],[[30,0,[\"socialProfileState\",\"action\",\"text\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,9],null,[[\"@openInstagramAuthStatus\",\"@socialProfile\",\"@socialProfileState\"],[[30,4],[30,1],[30,0,[\"socialProfileState\"]]]],null],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n    \"],[8,[39,6],[[24,0,\"o--btn o--btn--mute qa--socialProfile_remove_btn\"],[24,\"data-test-id\",\"profile-item-remove\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,5],[28,[37,3],[\"shared_words.remove\"],null],\"unstyled\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,1,[\"isTwitter\"]],[[[1,\"  \"],[10,\"tr\"],[12],[1,\"\\n    \"],[10,\"td\"],[14,0,\"tBD--tableDataAlert\"],[14,\"colspan\",\"4\"],[12],[1,\"\\n      \"],[8,[39,10],[[24,0,\"tBD--alert\"]],[[\"@type\"],[\"warning\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"rolloutTwitterSunset\"]],[[[1,\"          \"],[1,[28,[35,3],[\"twitter-deprecation.alert_banner.message_rollout\"],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,3],[\"twitter-deprecation.alert_banner.message\"],null]],[1,\"\\n\"]],[]]],[1,\"        \"],[8,[39,6],[[24,0,\"o--alert__btn o--alert--warning u--m__t__0\"]],[[\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[30,0,[\"enableTwitterDeprecationModal\"]],\"small\",[28,[37,3],[\"shared_words.learn_more\"],null],\"none\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showBasicDisplayDeprecation\"]],[[[1,\"  \"],[10,\"tr\"],[12],[1,\"\\n    \"],[10,\"td\"],[14,0,\"tBD--tableDataAlert\"],[14,\"colspan\",\"4\"],[12],[1,\"\\n      \"],[8,[39,10],[[24,0,\"tBD--alert\"]],[[\"@type\"],[\"warning\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"basic-display-deprecation.settings.description\"],null]],[1,\"\\n        \"],[8,[39,6],[[24,0,\"o--alert__btn o--alert--warning u--m__t__0\"]],[[\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[28,[37,7],[[30,0],\"showBasicDisplayDeprecationWizard\",true],null],\"small\",[28,[37,3],[\"basic-display-deprecation.settings.button\"],null],\"none\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showBasicDisplayDeprecationWizard\"]],[[[1,\"  \"],[8,[39,11],null,[[\"@closeWizard\",\"@returnToModal\"],[[28,[37,7],[[30,0],\"showBasicDisplayDeprecationWizard\",false],null],[28,[37,7],[[30,0],\"showBasicDisplayDeprecationWizard\",false],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showTwitterDeprecationModal\"]],[[[1,\"  \"],[8,[39,12],null,[[\"@closeModal\"],[[28,[37,7],[[30,0],\"showTwitterDeprecationModal\",false],null]]],null],[1,\"\\n\"]],[]],null]],[\"@socialProfile\",\"@openLinkedinProfileInfoModal\",\"@openTiktokConnectionStatusModal\",\"@openInstagramAuthStatus\",\"@disconnect\"],false,[\"if\",\"shared/profile-avatar\",\"ember-tooltip\",\"t\",\"on\",\"svg-jar\",\"shared/ui/button\",\"set\",\"html-safe\",\"cluster/social-profile-refresh\",\"alert-banner\",\"shared/social/basic-display-deprecation/wizard\",\"shared/social/twitter-deprecation/modal\"]]",
    "moduleName": "settings/components/cluster/social-profile-item.hbs",
    "isStrictMode": false
  });
  const TWITTER_DEPRECATION_MODAL_CACHE_KEY = 'twitter_deprecation_modal';
  let SocialProfileItemComponent = _exports.default = (_class = class SocialProfileItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "tiktok", _descriptor3, this);
      _initializerDefineProperty(this, "showTwitterDeprecationModal", _descriptor4, this);
      _defineProperty(this, "onboardBusiness", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.args.socialProfile.get('refreshAndReload').perform();
          if (!this.args.socialProfile.isBusiness) {
            window.open('https://help.later.com/hc/en-us/articles/360042770474', '_blank');
          }
        }
      }), null, "onboardBusiness", null));
    }
    get socialProfileState() {
      return this.args.socialProfile.socialProfileState;
    }
    get showProfileInfo() {
      return this.args.socialProfile.isInstagram;
    }
    get showBasicDisplayDeprecation() {
      return Boolean(this.args.socialProfile?.isInstagram && !this.args.socialProfile?.isProfessional);
    }
    get cacheKey() {
      return `${TWITTER_DEPRECATION_MODAL_CACHE_KEY}_${this.auth.currentGroup.id}`;
    }
    get rolloutTwitterSunset() {
      return Boolean(this.auth.currentAccount?.rolloutTwitterSunset);
    }
    addTiktokBusinessAccount() {
      this.tiktok.loginWithBusinessApiAccount(this.args.socialProfile);
    }
    openProfileInfo() {
      if (this.args.socialProfile.isInstagram) {
        this.args.openInstagramProfileInfo();
      }
      if (this.args.socialProfile.isTiktok) {
        this.args.openTiktokProfileInfo();
      }
    }
    enableTwitterDeprecationModal() {
      this.cache.remove(this.cacheKey);
      this.showTwitterDeprecationModal = true;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "tiktok", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showTwitterDeprecationModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "addTiktokBusinessAccount", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addTiktokBusinessAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openProfileInfo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openProfileInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableTwitterDeprecationModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "enableTwitterDeprecationModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialProfileItemComponent);
});